<template>
    <v-card v-if="profile && contact">
        <v-card-title class="text--white80 pa-0 pt-8 align-center">
            <v-btn icon class="text--white80 px-6" @click="goBack">
                <v-icon large left class="text--white80">mdi-arrow-u-left-top</v-icon>
            </v-btn>
            <span class="title font-weight-light">Account information</span>
            <v-spacer></v-spacer>
            <v-btn v-if="profile.isCaptain"
                   text
                   class="text--white80 white--text"
                   :disabled="boatImageBusy"
                   @click="openBoatImageDialog">
                <v-icon left class="white--text">mdi-image-edit-outline</v-icon>
                My Boat
            </v-btn>
        </v-card-title>
        <v-form ref="profileForm"
                class="col-12 backgroundWhite35 px-4 pt-4 pb-0"
                v-model="valid"
                lazy-validation>
              <div class="boat-background-panel"
                  :class="{ 'boat-background-panel--active': hasBoatBackgroundImage }"
                  :style="boatBackgroundStyle">
                 <div v-if="showBoatBackgroundLoader" class="boat-background-panel__loading">
                    <v-skeleton-loader type="image"
                                       class="boat-background-panel__skeleton"></v-skeleton-loader>
                 </div>
                 <div class="boat-background-panel__overlay"
                     :class="{ 'boat-background-panel__overlay--active': hasBoatBackgroundImage }">
                    <v-text-field v-model="profile.userId"
                                  class="text-input-white"
                                  color="white"
                                  readonly
                                  label="User identifier"></v-text-field>
                    <v-text-field v-model="contact.name"
                                  :counter="30"
                                  :readonly="!profile.isCaptain"
                                  :rules="nameRules"
                                  label="Captain's name"
                                  color="white"
                                  class="text-input-white"
                                  required></v-text-field>
                    <v-text-field v-model="profile.shipName"
                                  class="text-input-white"
                                  :counter="30"
                                  :readonly="!profile.isCaptain"
                                  label="Boat name"
                                  color="white"
                                  required></v-text-field>
                    <v-text-field v-model="profile.shipHomeLocation"
                                  class="text-input-white"
                                  label="Home location"
                                  :readonly="!profile.isCaptain"
                                  color="white"
                                  required></v-text-field>
                    <v-text-field v-model="profile.deviceId"
                                  class="text-input-white"
                                  readonly
                                  color="white"
                                  label="Device identifier"></v-text-field>
                    <v-container fluid :class="{'disabled-container': !profile.isCaptain}">
                <v-row>
                    <v-col cols="12">
                        <div class="d-flex flex-column">
                            <div>
                                <div class="text-matching-input-label">
                                    Captain's phone number
                                </div>
                                <vue-tel-input v-model="contact.phoneNumber" v-bind="vueTel.props" :disabled="!profile.isCaptain" @validate="phoneObject"></vue-tel-input>
                                <v-divider></v-divider>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
                </div>
            </div>
            

            <v-row v-if="profile.isCaptain" class="justify-center">
                <span class="white--text font-weight-bold pa-4">Captain Tools</span>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-email">
                            <template v-slot:default="{ open }">
                                E-mail Notifications
                                <span v-if="open" key="0" class="ml-auto header-helper-text pr-2 text-right">(click to close)</span>
                                <span v-else key="1" class="ml-auto header-helper-text pr-2 text-right">(click to expand)</span>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row justify="space-between" class="align-start">
                                <v-flex xs6>
                                    <v-col cols="12">
                                        <span class="caption" style="font-style: italic;">The following notifications will be sent in 'Armed' state if enabled.</span>
                                        <v-checkbox v-model="contact.gatewayPowerlossEmailActive" label="GTW Power Loss" prepend-icon="mdi-power-plug-off" class="py-0 my-0 pt-4" />
                                        <v-checkbox v-model="contact.shorePowerEmailActive" label="Shore Power" prepend-icon="mdi-meter-electric" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.smartplugEmailActive" label="Smart Plug" prepend-icon="mdi-power-plug" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.mainDoorEmailActive" label="Main Door" prepend-icon="mdi-door" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.hatchEmailActive" label="Hatch Door" prepend-icon="mdi-door" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.geofenceEmailActive" label="Geofence" prepend-icon="mdi-map-marker-radius" class="py-0 my-0" />
                                    </v-col>
                                </v-flex>
                                <v-divider vertical inset style="margin-top: 15px; margin-bottom: 30px;"></v-divider>
                                <v-flex xs6>
                                    <v-col cols="12">
                                        <span class="caption" style="font-style: italic;">The following notifications will be sent in any state if enabled.</span>
                                        <v-checkbox v-model="contact.gatewayTamperedEmailActive" label="GTW Tampered" prepend-icon="mdi-domino-mask" class="py-0 my-0 pt-4" />
                                        <v-checkbox v-model="contact.detectorsEmailActive" label="Detectors" prepend-icon="mdi-security" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.voltageLowEmailActive" label="Low Voltage" prepend-icon="mdi-sail-boat" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.lowBatterySensorEmailActive" label="Low Battery" prepend-icon="mdi-access-point" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.gsmConnectionLostEmailActive" label="GSM Connection Lost" prepend-icon="mdi-signal-off" class="py-0 my-0" />
                                    </v-col>
                                </v-flex>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-message-text">
                            <template v-slot:default="{ open }">
                                SMS Notifications
                                <span v-if="open" key="0" class="ml-auto header-helper-text pr-2 text-right">(click to close)</span>
                                <span v-else key="1" class="ml-auto header-helper-text pr-2 text-right">(click to expand)</span>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row justify="space-between" class="align-start">
                                <v-flex xs6>
                                    <v-col cols="12">
                                        <span class="caption" style="font-style: italic;">The following notifications will be sent in 'Armed' state if enabled.</span>
                                        <v-checkbox v-model="contact.gatewayPowerlossSMSActive" label="GTW Power Loss" prepend-icon="mdi-power-plug-off" class="py-0 my-0 pt-4" />
                                        <v-checkbox v-model="contact.shorePowerSMSActive" label="Shore Power" prepend-icon="mdi-meter-electric" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.smartPlugSMSActive" label="Smart Plug" prepend-icon="mdi-power-plug" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.mainDoorSMSActive" label="Main Door" prepend-icon="mdi-door" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.hatchSMSActive" label="Hatch Door" prepend-icon="mdi-calendar-minus" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.geofenceSMSActive" label="Geofence" prepend-icon="mdi-map-marker-radius" class="py-0 my-0" />
                                    </v-col>
                                </v-flex>
                                <v-divider vertical inset style="margin-top: 15px; margin-bottom: 30px;"></v-divider>
                                <v-flex xs6>
                                    <v-col cols="12">
                                        <span class="caption" style="font-style: italic;">The following notifications will be sent in any state if enabled.</span>
                                        <v-checkbox v-model="contact.gatewayTamperedSMSActive" label="GTW Tampered" prepend-icon="mdi-domino-mask" class="py-0 my-0 pt-4" />
                                        <v-checkbox v-model="contact.detectorsSMSActive" label="Detectors" prepend-icon="mdi-security" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.voltageLowSMSActive" label="Low Voltage" prepend-icon="mdi-sail-boat" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.lowBatterySensorSMSActive" label="Low Battery" prepend-icon="mdi-access-point" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.gsmConnectionLostSMSActive" label="GSM Connection Lost" prepend-icon="mdi-signal-off" class="py-0 my-0" />
                                    </v-col>
                                </v-flex>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-tune">
                            <template v-slot:default="{ open }">
                                Interface customization
                                <span v-if="open" key="0" class="ml-auto header-helper-text pr-2 text-right">(click to close)</span>
                                <span v-else key="1" class="ml-auto header-helper-text pr-2 text-right">(click to expand)</span>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-combobox v-model="selectedTimezone"
                                        :items="timezones"
                                        label="Timezone"
                                        outlined
                                        @change="updateTimezone"></v-combobox>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-account-group">
                            <template v-slot:default="{ open }">
                                Connected Accounts
                                <span v-if="open" key="0" class="ml-auto header-helper-text pr-2 text-right">(click to close)</span>
                                <span v-else key="1" class="ml-auto header-helper-text pr-2 text-right">(click to expand)</span>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>

                            <v-card class="mx-auto pb-0" tile>

                                <v-list two-line>
                                    <div class="d-flex" style="justify-content: space-between;">
                                        <div class="text-left black--text font-weight-regular header-text-size pl-4" style="width: auto;">
                                            User Account
                                        </div>
                                        <div class="text-center black--text font-weight-regular header-text-size px-4" style="width: 210px; text-align: right;">
                                            Options
                                        </div>
                                    </div>
                                    <v-list-item v-for="(item, index) in connectedAccount" :key="index">

                                            <v-list-item-content>
                                                <v-list-item-title>{{ item.userId }}</v-list-item-title>
                                                <v-list-item-subtitle v-if="item.isApproved" class="green--text">
                                                    <v-icon small class="green--text">mdi-shield-check </v-icon> User has access!
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle v-else class="red--text">
                                                    <v-icon small class="red--text">mdi-lock</v-icon> User is locked out!
                                                </v-list-item-subtitle>
                                            </v-list-item-content>

                                            <v-list-item-action class="ml-2 mr-3">
                                                <v-list-item-action-text>Gallery</v-list-item-action-text>
                                                <v-switch v-model="item.hasGalleryAccess" :color="item.hasGalleryAccess ? 'success' : 'error'" @change="changeGalleryAccess(item)">
                                                </v-switch>
                                            </v-list-item-action>
                                            <v-list-item-action class="ml-2 mr-3">
                                                <v-list-item-action-text>Upload</v-list-item-action-text>
                                                <v-switch v-model="item.hasUploadAccess" :color="item.hasUploadAccess ? 'success' : 'error'" @change="changeUploadAccess(item)">
                                                </v-switch>
                                            </v-list-item-action>
                                            <v-list-item-action v-if="!item.isApproved" class="mx-2">
                                                <v-list-item-action-text class="pr-1">Allow</v-list-item-action-text>
                                                <v-icon color="success" icon large @click.prevent="authorizeAccount(item)">
                                                    mdi-shield-check
                                                </v-icon>
                                            </v-list-item-action>
                                            <v-list-item-action v-if="item.isApproved" class="mx-2">
                                                <v-list-item-action-text class="pr-1">Lock</v-list-item-action-text>
                                                <v-icon color="error" icon large @click.prevent="deauthorizeConnectedAccount(item)">
                                                    mdi-lock
                                                </v-icon>
                                            </v-list-item-action>
                                            <v-list-item-action class="mx-2">
                                                <v-list-item-action-text>Delete</v-list-item-action-text>

                                                <v-icon color="error" icon large @click.prevent="deleteConnectedAccount(item)">
                                                    mdi-delete
                                                </v-icon>
                                            </v-list-item-action>
                                        </v-list-item>
                                </v-list>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-database">
                            <template v-slot:default="{ open }">
                                Consumption
                                <span v-if="open" key="0" class="ml-auto header-helper-text pr-2 text-right">(click to close)</span>
                                <span v-else key="1" class="ml-auto header-helper-text pr-2 text-right">(click to expand)</span>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-card class="mx-auto pb-0" tile>
                                <v-card-subtitle class="pb-0">
                                    <v-row>
                                        <v-col cols="12" class="pb-0 pt-1">
                                            <div class="text-left black--text font-weight-regular header-text-size">Consumption period: {{ formattedBillingStart }} - {{ formattedBillingEnd }}</div>
                                        </v-col>
                                    </v-row>
                                </v-card-subtitle>
                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title> Data </v-list-item-title>
                                        <v-list-item-subtitle>
                                            <v-progress-linear :value="dataUsage"
                                                               :color="dataUsage > 80 ? 'error' : 'blue-grey'"
                                                               height="25">
                                                <template v-slot:default="{ value }">
                                                    <strong>{{ profile.mBsUsed }} MB / {{ profile.dataLimit }} MB ({{ value }}%)</strong>
                                                </template>
                                            </v-progress-linear>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title> Transactions </v-list-item-title>
                                        <v-list-item-subtitle>
                                            <v-progress-linear :value="transactionUsage"
                                                               :color="transactionUsage > 80 ? 'error' : 'blue-grey'"
                                                               height="25">
                                                <template v-slot:default="{ value }">
                                                    <strong>{{ profile.transactionsUsed }} / {{ profile.transactionsLimit }} ({{ value }}%)</strong>
                                                </template>
                                            </v-progress-linear>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-currency-eur">
                            <template v-slot:default="{ open }">
                                Subscription
                                <span v-if="open" key="0" class="ml-auto header-helper-text pr-2 text-right">(click to close)</span>
                                <span v-else key="1" class="ml-auto header-helper-text pr-2 text-right">(click to expand)</span>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-card class="mx-auto pb-0" tile>
                                <v-card-subtitle class="pb-0">
                                    <v-row>
                                        <v-col cols="12" class="pb-0 pt-1">
                                            <div class="text-left black--text font-weight-regular header-text-size">Subscription period: {{ formattedSubscriptionStart }} - {{ formattedSubscriptionEnd }}</div>
                                        </v-col>
                                    </v-row>
                                </v-card-subtitle>
                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title> You are subscribed since </v-list-item-title>
                                        <v-list-item-subtitle>
                                            {{ formattedSubscribedSinceDate }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title> Your plan will renew on </v-list-item-title>
                                        <v-list-item-subtitle>
                                            {{ formattedRenewalDate }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title> Subscription interval </v-list-item-title>
                                        <v-list-item-subtitle>
                                            {{ billingInterval }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-btn @click="manageSubscription" color="primary">
                                            <v-icon left>
                                                mdi-cog-sync-outline
                                            </v-icon>
                                            SUBSCRIPTION MANAGEMENT
                                        </v-btn>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-row>

            <v-row>
                <v-col cols="4" class="text-left pr-0">
                    <v-btn color="error"
                           @click="logout">
                        LOGOUT
                        <v-icon right>
                            mdi-logout
                        </v-icon>
                    </v-btn>
                </v-col>
                <v-col col="4" class="text-center px-0">
                    <v-btn @click="manageAcc">
                        <v-icon left>
                            mdi-account-cog-outline
                        </v-icon>
                        MANAGE
                    </v-btn>
                </v-col>
                <v-col cols="4" class="text-right pl-0">
                    <v-btn :disabled="!valid || !isValid"
                           color="success"
                           class="px-7"
                           @click="initSave">
                        <v-icon left>
                            mdi-check
                        </v-icon>
                        SAVE
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <ConfirmDialog v-model="showRemove"
                       title="Delete connected account"
                       message="Do you want to delete the connected account ?"
                       @OnOk="removeOk"></ConfirmDialog>
        <ConfirmDialog v-model="showLockout"
                       title="Lock out connected account"
                       message="Do you want to lock out the connected account ?"
                       @OnOk="lockoutOk"></ConfirmDialog>
        <ConfirmDialog v-model="showAuthorize"
                       title="Authorize connected account"
                       message="Do you want to authorize the connected account ?"
                       @OnOk="authorizeOk"></ConfirmDialog>
        <ConfirmDialog v-model="showSuccess"
                       :options="{ noconfirm: true }"
                       title="Success"
                       message="Changes saved successfully."
                       @OnOk="successOk"></ConfirmDialog>
        <ConfirmDialog v-model="showLeaveConfirm"
                       :options="{ persistent: true }"
                       title="Unsaved Changes"
                       message="You have unsaved changes. Do you really want to leave without saving?"
                       @OnOk="leaveWithoutSaving" />
        <ImageUploadDialog :value="showBoatImageDialog"
                           title="Boat background"
                           :image-url="boatBackgroundUrl"
                           empty-state-text="No boat background uploaded yet."
                           :busy="boatImageBusy"
                           :show-file-input="canManageBoatImage"
                           :show-delete="canManageBoatImage && !!profile.boatImage"
                           :show-upload="canManageBoatImage"
                           :upload-disabled="!canManageBoatImage || !selectedBoatImageFile"
                           :file-rules="boatImageRules"
                           :file-value="selectedBoatImageFile"
                           @input="setBoatImageDialog"
                           @file-change="handleBoatImageFileChange"
                           @delete="deleteBoatImage"
                           @upload="uploadBoatImage"></ImageUploadDialog>
        <v-row justify="center" align="center">
            <v-col cols="12" class="text--white80 text-right info-location pr-4">
                App version: 0.1.3 alpha
            </v-col>
        </v-row>
    </v-card>
</template>
<script lang="ts">
    import { profile as profilestore, app } from "@/store/index";
    import { configureOidc } from "@/store/services/security.service";
    import { stopMessageHub } from "@/plugins/messageHub";
    import { OidcAuth } from "vue-oidc-client/vue2";
    import { VueTelInput } from "vue-tel-input";
    import ContactViewModel from "@/models/ContactViewModel";
    import useContact from "@/store/useContact";
    import useConnectedAccount from "@/store/useConnectedAccount";
    import moment from "moment-timezone";
    import { computed, defineComponent, onBeforeUnmount, onMounted, ref, getCurrentInstance, watch } from "vue";
    import ProfileViewModel from "@/models/ProfileViewModel";
    import ConnectedAccountViewModel from "@/models/ConnectedAccountViewModel";
    import SubscriptionViewModel from "@/models/SubscriptionViewModel";
    import useSubscription from "@/store/useSubscription";
    import useUserSettings from "@/store/useUserSettings";
    import UserSettingsViewModel from "@/models/UserSettingsViewModel";
    import { deleteImageFromBlobStorage, downloadImageFromBlobStorage, uploadImageToBlobStorage } from "@/store/useUserPictureStorage";

    window.addEventListener('unhandledrejection', event => {
        console.error('Unhandled promise rejection:', event.reason);
    });

    export default defineComponent({
        name: "Profile",
        components: {
            VueTelInput,
            ConfirmDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/ConfirmDialog.vue"),
            ImageUploadDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/ImageUploadDialog.vue")
        },
        setup() {
            const root = getCurrentInstance()?.proxy as any;
            const lodash = root.$_;
            const { update, getCaptain, nameRules, emailRules } = useContact();
            const { connectedAccount, get, remove, approve, lockout,
                allowGallery, denyGallery, allowUpload, denyUpload } = useConnectedAccount();
            const { getSubscription } = useSubscription();
            const { getUserSettings, updateUserSettings } = useUserSettings();
            const allowLeave = ref<boolean>(false);

            const contact = ref<ContactViewModel>();
            const profile = computed<ProfileViewModel>(() => profilestore.profile);
            const subscription = ref<SubscriptionViewModel>();
            const userSettings = ref<UserSettingsViewModel>();

            const originalProfile = ref<ProfileViewModel>();
            const originalContact = ref<ContactViewModel>();

            const valid = ref<boolean>(true);
            const showSuccess = ref<boolean>(false);
            const showRemove = ref<boolean>(false);
            const showLockout = ref<boolean>(false);
            const showAuthorize = ref<boolean>(false);
            const showLeaveConfirm = ref<boolean>(false);
            const pendingRoute = ref<null | ((allow?: boolean) => void)>(null);

            const profileForm = ref<HTMLFormElement>();
            const userId = ref<string>("");

            const selectedTimezone = ref<string>("");
            const timezones = ref([]);
            const showBoatImageDialog = ref<boolean>(false);
            const selectedBoatImageFile = ref<File | null>(null);
            const boatBackgroundUrl = ref<string>("");
            const boatImageBusy = ref<boolean>(false);
            const boatBackgroundLoading = ref<boolean>(false);
            let boatImageLoadVersion = 0;

            const boatImageRules = ref([
                (value: File) => !value || (value.size < 5 * 1024 * 1024 && ['image/jpeg', 'image/png'].includes(value.type)) || 'Image size should be less than 5 MB and in JPG or PNG format!',
            ]);

            const boatBackgroundStyle = computed<Record<string, string>>(() => {
                if (!boatBackgroundUrl.value) {
                    return {};
                }

                return {
                    backgroundImage: `linear-gradient(rgba(17, 24, 58, 0.58), rgba(17, 24, 58, 0.78)), url(${boatBackgroundUrl.value})`
                };
            });

            const canManageBoatImage = computed<boolean>(() => !!profile.value?.isCaptain);
            const hasBoatBackgroundImage = computed<boolean>(() => !!boatBackgroundUrl.value);
            const showBoatBackgroundLoader = computed<boolean>(() => boatBackgroundLoading.value && !!profile.value?.boatImage);

            const revokeBoatBackgroundUrl = () => {
                if (boatBackgroundUrl.value) {
                    URL.revokeObjectURL(boatBackgroundUrl.value);
                    boatBackgroundUrl.value = "";
                }
            };

            const loadBoatBackgroundImage = async () => {
                const currentLoadVersion = ++boatImageLoadVersion;
                revokeBoatBackgroundUrl();

                if (!profile.value || !profile.value.boatImage) {
                    boatBackgroundLoading.value = false;
                    return;
                }

                boatBackgroundLoading.value = true;

                try {
                    const imageData = await downloadImageFromBlobStorage(profile.value.boatImage);
                    if (currentLoadVersion !== boatImageLoadVersion || !imageData.length) {
                        return;
                    }

                    const blob = new Blob([imageData.buffer as ArrayBuffer], { type: 'image/jpeg' });
                    boatBackgroundUrl.value = URL.createObjectURL(blob);
                } finally {
                    if (currentLoadVersion === boatImageLoadVersion) {
                        boatBackgroundLoading.value = false;
                    }
                }
            };

            const resetBoatImageSelection = () => {
                selectedBoatImageFile.value = null;
            };

            const openBoatImageDialog = () => {
                if (!canManageBoatImage.value) {
                    return;
                }

                resetBoatImageSelection();
                showBoatImageDialog.value = true;
            };

            const closeBoatImageDialog = () => {
                if (boatImageBusy.value) return;
                resetBoatImageSelection();
                showBoatImageDialog.value = false;
            };

            const setBoatImageDialog = (value: boolean) => {
                if (value) {
                    showBoatImageDialog.value = true;
                    return;
                }

                closeBoatImageDialog();
            };

            const handleBoatImageFileChange = (file: File | undefined) => {
                if (!canManageBoatImage.value) {
                    return;
                }

                selectedBoatImageFile.value = file ?? null;
            };

            const generateBoatImageFileName = (length = 32): string => {
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                let result = '';

                for (let i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * characters.length));
                }

                return `${profile.value.deviceId}_${result}.jpeg`;
            };

            const persistBoatImageProfile = async (successMessage: string) => {
                await profilestore.Update(profile.value);
                originalProfile.value = lodash.cloneDeep(profile.value);
                app.success = successMessage;
            };

            const uploadBoatImage = async () => {
                if (!canManageBoatImage.value || !profile.value || !selectedBoatImageFile.value) {
                    return;
                }

                boatImageBusy.value = true;
                const previousBoatImage = profile.value.boatImage;
                const nextBoatImage = generateBoatImageFileName();

                try {
                    await uploadImageToBlobStorage(nextBoatImage, new Uint8Array(await selectedBoatImageFile.value.arrayBuffer()));

                    profile.value.boatImage = nextBoatImage;

                    try {
                        await persistBoatImageProfile("Boat background updated.");
                    } catch (error) {
                        profile.value.boatImage = previousBoatImage;
                        await deleteImageFromBlobStorage(nextBoatImage);
                        throw error;
                    }

                    if (previousBoatImage) {
                        await deleteImageFromBlobStorage(previousBoatImage);
                    }

                    await loadBoatBackgroundImage();
                    closeBoatImageDialog();
                } catch (error) {
                    console.error('Error uploading boat image:', error);
                    app.error = "Failed to update the boat background.";
                } finally {
                    boatImageBusy.value = false;
                }
            };

            const deleteBoatImage = async () => {
                if (!canManageBoatImage.value || !profile.value || !profile.value.boatImage) {
                    return;
                }

                boatImageBusy.value = true;
                const previousBoatImage = profile.value.boatImage;

                try {
                    profile.value.boatImage = "";
                    await persistBoatImageProfile("Boat background removed.");
                    await deleteImageFromBlobStorage(previousBoatImage);
                    revokeBoatBackgroundUrl();
                    closeBoatImageDialog();
                } catch (error) {
                    profile.value.boatImage = previousBoatImage;
                    console.error('Error deleting boat image:', error);
                    app.error = "Failed to remove the boat background.";
                } finally {
                    boatImageBusy.value = false;
                }
            };

            const logout = () => {
                configureOidc().then((oidc: OidcAuth) => {
                    stopMessageHub().finally(() => oidc.signOut()).catch(err => {
                        console.error('OIDC configuration or sign-out failed:', err);
                        window.location.href = "/Identity/Account/Logout";
                    });
                });
            };

            const initSave = () => {
                if (profileForm.value) {
                    valid.value = profileForm.value.validate();
                    if (valid.value && profile.value && contact.value) {
                        profilestore.Update(profile.value);
                        update(contact.value).then(() => {
                            // refresh originals after save
                            originalProfile.value = lodash.cloneDeep(profile.value);
                            originalContact.value = lodash.cloneDeep(contact.value);
                            showSuccess.value = true;
                        });
                    }
                }
            };

            const vueTel = {
                phone: "",
                props: {
                    autoFormat: true,
                    autoDefaultCountry: true,
                    dropdownOptions: {
                        showDialCodeInList: true,
                        showDialCodeInSelection: false,
                        showFlags: true,
                        showSearchBox: true,
                        width: '300px',
                    },
                    ignoredCountries: ["KP", "RU"],
                    inputOptions: {
                        autocomplete: 'on',
                        showDialCode: true,
                        placeholder: 'Enter phone number',
                        required: true,
                    },
                    mode: "international",
                    preferredCountries: ["DK", "NO", "SE"],
                    validCharactersOnly: true,
                }
            };

            const hasUnsavedChanges = () => {
                const profileChanged = !lodash.isEqual(profile.value, originalProfile.value);
                const contactChanged = !lodash.isEqual(contact.value, originalContact.value);
                return profileChanged || contactChanged;
            };

            const setPendingRoute = (next) => {
                pendingRoute.value = next;
            };

            const goBack = () => {
                if (hasUnsavedChanges()) {
                    pendingRoute.value = null;
                    showLeaveConfirm.value = true;
                } else {
                    window.history.back();
                }
            };

            const leaveWithoutSaving = () => {
                allowLeave.value = true;
                if (pendingRoute.value) {
                    const next = pendingRoute.value;
                    pendingRoute.value = null;
                    next();
                } else {
                    window.history.back();
                }
            };

            const successOk = () => { showSuccess.value = false; };
            const manageAcc = () => { window.location.href = "/Identity/Account/Manage"; };
            const manageSubscription = () => { window.open("https://billing.stripe.com/p/login/test_cN2aFac1ngye556dQQ", "_blank"); };

            const deleteConnectedAccount = (connectedAccount: ConnectedAccountViewModel) => {
                userId.value = connectedAccount.userId;
                showRemove.value = true;
            };

            const changeGalleryAccess = (connectedAccount: ConnectedAccountViewModel) => {
                userId.value = connectedAccount.userId;

                if (connectedAccount.hasGalleryAccess) {
                    allowGallery(userId.value).then(() => {
                        get();
                        app.success = "Galerry access allowed. Changes may take up to 90s to take effect.";
                    })
                } else {
                    denyGallery(userId.value).then(() => {
                        get();
                        app.success = "Galerry access denied. Changes may take up to 90s to take effect.";
                    })
                }
            };

            const changeUploadAccess = (connectedAccount: ConnectedAccountViewModel) => {
                userId.value = connectedAccount.userId;

                if (connectedAccount.hasUploadAccess) {
                    allowUpload(userId.value).then(() => {
                        get();
                        app.success = "Upload access allowed. Changes may take up to 90s to take effect.";
                    })
                } else {
                    denyUpload(userId.value).then(() => {
                        get();
                        app.success = "Upload access denied. Changes may take up to 90s to take effect.";
                    })
                }
            };

            const authorizeAccount = (connectedAccount: ConnectedAccountViewModel) => {
                userId.value = connectedAccount.userId;
                showAuthorize.value = true;
            };

            const deauthorizeConnectedAccount = (connectedAccount: ConnectedAccountViewModel) => {
                userId.value = connectedAccount.userId;
                showLockout.value = true;
            };

            const lockoutOk = () => {
                lockout(userId.value).then(() => {
                    get();
                    showRemove.value = false;
                    app.success = "Account locked out. Changes may take up to 90s to take effect.";
                });
            };

            const removeOk = () => {
                remove(userId.value).then(() => {
                    get();
                    showRemove.value = false;
                    app.success = "Account removed. Changes may take up to 90s to take effect.";
                });
            };

            const authorizeOk = () => {
                approve(userId.value).then(() => {
                    get();
                    showAuthorize.value = false;
                    app.success = "Account authorized. Changes may take up to 90s to take effect.";
                })
            };

            const dataUsage = computed<number>(() => {
                if (profile.value) {
                    return parseInt(((profile.value.mBsUsed / profile.value.dataLimit) * 100).toFixed(0));
                }
                return 0;
            });

            const transactionUsage = computed<number>(() => {
                if (profile.value) {
                    return parseInt(((profile.value.transactionsUsed / profile.value.transactionsLimit) * 100).toFixed(0));
                }
                return 0;
            });

            const formattedBillingStart = computed<string>(() => {
                return profile.value ? formatDateString(profile.value.billingStart) : 'N/A';
            });

            const formattedBillingEnd = computed<string>(() => {
                return profile.value ? formatDateString(profile.value.billingEnd) : 'N/A';
            });

            const formattedSubscriptionStart = computed<string>(() => {
                return subscription.value ? formatDateString(subscription.value.currentPeriodStart) : "N/A";
            });

            const formattedSubscriptionEnd = computed<string>(() => {
                return subscription.value ? formatDateString(subscription.value.currentPeriodEnd) : 'N/A';
            });

            const billingInterval = computed<string>(() => {
                return subscription.value ? capitalizeFirstLetter(subscription.value.billingInterval + "ly") : 'N/A';
            });

            const formattedRenewalDate = computed<string>(() => {
                return subscription.value ? formatDateString(subscription.value.currentPeriodEnd) : 'N/A';
            });

            const formattedSubscribedSinceDate = computed<string>(() => {
                return subscription.value ? formatDateString(subscription.value.subscriptionStartDate) : 'N/A';
            });

            function capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            }

            function formatDateString(dateString: string): string {
                const date = new Date(dateString);
                const day = date.getDate();
                const month = date.toLocaleString('en-US', { month: 'long' });
                const year = date.getFullYear();

                let daySuffix = 'th';
                if (day === 1 || day === 21 || day === 31) {
                    daySuffix = 'st';
                } else if (day === 2 || day === 22) {
                    daySuffix = 'nd';
                } else if (day === 3 || day === 23) {
                    daySuffix = 'rd';
                }

                return `${day}${daySuffix} of ${month}, ${year}`;
            }

            const updateTimezone = () => {
                if (!timezones.value.includes(selectedTimezone.value)) {
                    console.warn('Selected timezone is invalid:', selectedTimezone.value);
                    return;
                }
                userSettings.value.timezone = selectedTimezone.value;
                updateUserSettings(userSettings.value)
                    .then(() => {
                        app.success = "Captain timezone updated";
                    })
                    .catch(err => console.error('Error updating timezone:', err));
            };

            getUserSettings().then((value: UserSettingsViewModel) => {
                userSettings.value = value;
                selectedTimezone.value = userSettings.value.timezone;
            });

            getSubscription().then((model: SubscriptionViewModel) => {
                subscription.value = model;
            });

            onMounted(async () => {
                await profilestore.Get();
                void loadBoatBackgroundImage();
                const model = await getCaptain("elCapitano");
                contact.value = model ?? new ContactViewModel();

                originalContact.value = lodash.cloneDeep(contact.value);
                originalProfile.value = lodash.cloneDeep(profilestore.profile);

                timezones.value = moment.tz.names();
                subscription.value = await getSubscription();
                userSettings.value = await getUserSettings();
                selectedTimezone.value = userSettings.value.timezone;
            });

            watch(
                () => profile.value?.boatImage,
                () => {
                    void loadBoatBackgroundImage();
                }
            );

            onBeforeUnmount(() => {
                revokeBoatBackgroundUrl();
            });

            return {
                profile,
                profileForm,
                logout,
                manageAcc,
                successOk,
                initSave,
                showLeaveConfirm,
                leaveWithoutSaving,
                showSuccess,
                showRemove,
                showLockout,
                showAuthorize,
                deleteConnectedAccount,
                lockoutOk,
                removeOk,
                deauthorizeConnectedAccount,
                vueTel,
                contact,
                nameRules,
                emailRules,
                goBack,
                authorizeAccount,
                authorizeOk,
                connectedAccount,
                dataUsage,
                transactionUsage,
                valid,
                formattedBillingStart,
                formattedBillingEnd,
                formattedSubscriptionStart,
                formattedSubscriptionEnd,
                formattedRenewalDate,
                formattedSubscribedSinceDate,
                billingInterval,
                manageSubscription,
                timezones,
                selectedTimezone,
                updateTimezone,
                changeGalleryAccess,
                changeUploadAccess,
                hasUnsavedChanges,
                setPendingRoute,
                allowLeave,
                setBoatImageDialog,
                canManageBoatImage,
                hasBoatBackgroundImage,
                showBoatBackgroundLoader,
                boatBackgroundStyle,
                boatBackgroundUrl,
                boatImageBusy,
                boatImageRules,
                closeBoatImageDialog,
                deleteBoatImage,
                handleBoatImageFileChange,
                openBoatImageDialog,
                selectedBoatImageFile,
                showBoatImageDialog,
                uploadBoatImage,
            };
        },
        beforeRouteLeave(to, from, next) {
            if (this.allowLeave) {
                this.allowLeave = false;
                next();
                return;
            }
            if (this.hasUnsavedChanges && this.hasUnsavedChanges()) {
                this.setPendingRoute(next);
                this.showLeaveConfirm = true;
            } else {
                next();
            }
        },
        data: () => ({ isValid: false }),
        methods: {
            phoneObject(object) {
                this.isValid = object.valid === true;
            },
        }
    });
</script>
<style scoped lang="scss">
    .v-card ::v-deep .text-input-white .v-text-field__slot input {
        color: #fff !important;
    }

    ::v-deep .vue-tel-input .vti__input {
        color: #fff !important;
    }

    ::v-deep .vue-tel-input .vti__dropdown-list {
        background-color: #203262 !important;
    }

    ::v-deep .vue-tel-input .vti__dropdown-item {
        color: #fff !important;
    }

    ::v-deep .vue-tel-input .vti__dropdown-item.highlighted {
        background-color: #11183a;
    }

    ::v-deep .v-input .v-input__control .v-input__slot {
        align-items: start;
    }

    .header-helper-text {
        font-size: 14px;
        color: gray;
    }

    .text-matching-input-label {
        font-size: 11px !important;
        color: #0009 !important;
        font-size: .75rem !important;
    }

    .disabled-container {
        opacity: 0.7;
        pointer-events: none;
    }

    .info-location {
        font-size: 12px;
    }

    .header-text-size {
        font-size: 12px;
    }

    .boat-background-panel {
        border-radius: 16px;
        min-height: 356px;
        margin-bottom: 12px;
        padding: 16px 16px 4px;
        position: relative;
        overflow: hidden;
    }

    .boat-background-panel--active {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .boat-background-panel__overlay {
        background: transparent;
        position: relative;
        z-index: 1;
    }

    .boat-background-panel__overlay--active {
        background: transparent;
    }

    .boat-background-panel__loading {
        border-radius: 16px;
        inset: 0;
        overflow: hidden;
        position: absolute;
        z-index: 0;
    }

    .boat-background-panel__skeleton {
        height: 100%;
        width: 100%;
    }

    .boat-background-panel__loading ::v-deep .v-skeleton-loader__image {
        height: 100%;
    }

    // Background color for Timezones dropdown, default transparent
    .v-sheet.v-list {
        background-color: white !important;
    }
</style>